module.exports = __webpack_public_path__ + "static/product_design_icon-37f1d694b33f80150b6aed56fa83e57a.png";